export default "__VITE_ASSET__CIBPORgW__"